import { styled, TablePagination } from "@mui/material";

const AppPagination = styled(TablePagination)(() => ({
    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
        fontSize: 15,
        color: `#333`,
    },
})) as typeof TablePagination;

export default AppPagination;
